import { useBulkActionsState } from './useBulkActionsState';
export const useBulkActionsWarmupCacheForStateSlice = () => {
  const state = useBulkActionsState();
  return state.warmupCacheFor;
};